export const environment = {
  production: true,
  apiBaseUrl: 'https://staging-api.imanagerportal.com',
};
